import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'Common/ReactTableWrapper';
import { Icon } from 'semantic-ui-react';
import moment from 'moment';

import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { formatDecimal } from 'Common/FormHelper';
import { dateSortMethod, numericSortMethod } from 'Common/GridHelper';

export class DailyDepositTable extends Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    cogOptions: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    closeSchoolYearClosedDate: PropTypes.object,
  };

  static defaultProps = {
    loading: false,
  };

  columns = [
    {
      Header: 'Site Id',
      id: 'SiteId',
      accessor: 'SiteId',
      Cell: props =>
        props.original.isEditDisabled ? `*${props.value}` : props.value,
    },
    {
      Header: 'Site Description',
      accessor: 'SiteDescription',
    },
    {
      Header: 'Serving Site Id',
      id: 'PrimarySiteId',
      accessor: 'PrimarySiteId',
    },
    {
      Header: 'Serving Site Description',
      accessor: 'PrimarySiteDescription',
      width: 170,
    },
    {
      Header: 'Closing Date',
      id: 'date',
      accessor: row => defaultDateFormat(row.ClosingDate),
      sortMethod: dateSortMethod,
    },
    {
      Header: 'Deposit Amount',
      id: 'deposit',
      accessor: row => formatDecimal(2)(row.DepositAmount),
      sortMethod: numericSortMethod,
    },
    {
      Header: 'Added/Modified',
      id: 'modified',
      sortMethod: (a, b) => {
        if (!a || !b) {
          return !b ? 1 : -1;
        }
        return a.props.children[0].props.name > b.props.children[0].props.name
          ? 1
          : -1;
      },
      accessor: row =>
        row.IsNew === 1 ? (
          <Fragment>
            <Icon name="plus" title="This deposit was added by a user." />
            Added
          </Fragment>
        ) : row.IsModified === 1 ? (
          <Fragment>
            <Icon name="pencil" title="This deposit was modified by a user." />
            Modified
          </Fragment>
        ) : (
          undefined
        ),
    },
    {
      width: 50,
      sortable: false,
      Cell: gridProps => {
        return GridContextMenu({
          gridProps,
          options: this.props.cogOptions,
        });
      },
    },
  ];

  isEditDisabled = closingDate => {
    return moment(closingDate).isSameOrBefore(
      this.props.closeSchoolYearClosedDate,
      'day'
    );
  };

  render() {
    const {
      data,
      loading,
      reactTableRef,
      handlePageChange,
      handleSortedChange,
    } = this.props;

    return (
      <ReactTable
        saveState={{
          tableName: TableNamesEnum.MODIFY_DAILY_DEPOSIT_TABLE,
          page: false,
        }}
        loading={loading}
        reactTableRef={reactTableRef}
        data={data}
        onPageChange={handlePageChange}
        onSortedChange={handleSortedChange}
        resolveData={data =>
          data.map(row => ({
            ...row,
            isEditDisabled: this.isEditDisabled(row.ClosingDate),
          }))
        }
        columns={this.columns}
        menu={'hasCogs'}
        defaultSorted={[
          {
            id: 'date',
            desc: true,
          },
          {
            id: 'SiteId',
            desc: false,
          },
        ]}
        getTrGroupProps={(state, rowInfo, column) => {
          const props = {};
          if (rowInfo && rowInfo.original.isEditDisabled) {
            props['className'] = 'disable-edit';
          }
          return props;
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/modifydailydeposits/components/DailyDepositTable.js